import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {DialogError} from '@mintdata-wsp/wsp/ui/components/forms/DialogError';
import {ErrorPopupSide, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {TextRun} from '@mintdata-wsp/wsp/ui/components/text/TextRun';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./TextInputDialog.less');
const cx = classnames.bind(styles);

export enum TextInputDialogButtonSet
{
    YES_NO = 1,
    OK_CANCEL = 2,
}

export class TextInputDialogProps
{
    constructor(
        public intent:MDIntent = MDIntent.Warning,
        public title:string = null,
        public message:string = null,
        public label:string = null,
        public placeholder:string = null,
        public initialValue:string = null,
        public data:any,
        public buttonSet:TextInputDialogButtonSet | string[] = TextInputDialogButtonSet.OK_CANCEL,
        public onConfirmed:(inputValue:string, data:any) => (void | boolean),
        public onCancelled?:(data:any) => (void),
        public isTextInitiallySelected:boolean = true,
        public onChange?:(value:string) => (void),
        public getErrorMessage?:() => (string),
    )
    {
    }
}

@observer
export class TextInputDialog extends React.Component<TextInputDialogProps, any>
{
    private _latestInputValue:string = null;

    constructor(props:any)
    {
        super(props);
    }

    @bind
    private _onChange(newValue:string)
    {
        let {onChange} = this.props;

        this._latestInputValue = newValue;

        if( onChange && typeof onChange === 'function' )
            onChange(newValue);

        return true;
    }

    @bind
    _onConfirmed()
    {
        let {data, onConfirmed} = this.props;

        if( onConfirmed && typeof onConfirmed === 'function' )
        {
            const canHideDialog = onConfirmed(this._latestInputValue, data);

            if( canHideDialog === false )
                return;
        }
        this._hideDialog();
    }

    @bind
    _onCancelled()
    {
        let {data, onCancelled} = this.props;

        this._hideDialog();

        if( onCancelled && typeof onCancelled === 'function' )
            onCancelled(data);
    }

    @bind
    private _hideDialog()
    {
        controllers.ui.dialogs.hideDialog(Dialogs.TextInput);
    }

    _renderButtonsRow()
    {
        let {buttonSet = TextInputDialogButtonSet.YES_NO, intent = MDIntent.Default} = this.props;

        let buttonTitles:string[];

        switch( buttonSet )
        {
            case TextInputDialogButtonSet.OK_CANCEL:
                buttonTitles = ['Cancel', 'OK'];
                break;
            case TextInputDialogButtonSet.YES_NO:
                buttonTitles = ['No', 'Yes'];
                break;
            default:
                buttonTitles = buttonSet;
        }

        return (
            <Row className={cx('buttonsRow')}>
                {buttonTitles[0] && <DialogButton
                    caption={buttonTitles[0]}
                    intent={MDIntent.Default}
                    style={ButtonStyle.SimpleSecondary}
                    onClick={this._onCancelled}
                    className={styles.cancelBtn}
                />}

                {buttonTitles[1] && <DialogButton
                    caption={buttonTitles[1]}
                    intent={intent}
                    onClick={this._onConfirmed}
                />}
            </Row>
        );
    }

    render()
    {
        let {intent = MDIntent.Default, title, message, label, placeholder, initialValue, isTextInitiallySelected, getErrorMessage} = this.props;

        const errorMessage = getErrorMessage ? getErrorMessage() : '';

        return (
            <Dialog
                title={title}
                onClose={this._onCancelled}
            >
                <DialogError message={errorMessage} />

                <Column className={cx('contentColumn')}>

                    {
                        message
                            ? <TextRun className={cx('textMessage')}>
                                <b>{message}</b>
                            </TextRun>
                            : null
                    }

                    <TextRun className={cx('textInput')}>

                        <InputField
                            className={cx('inputField')}
                            style={InputStyle.Dialog}
                            isInitiallyFocused={true}
                            isInitiallySelected={isTextInitiallySelected}
                            labelClassName={cx('inputFieldLabel')}
                            label={label}
                            icon={null}
                            placeholder={placeholder}
                            errorPopupSide={ErrorPopupSide.Bottom}
                            initialValue={initialValue}
                            isValidFn={(value:string) =>
                            {
                                return true;
                                // return value && value.length > 0;
                            }}
                            // getErrorMessageFn={(value:string)=>
                            // {
                            //     return null;
                            //     // return `Please enter a value for ${p.name} | ( "${value}" was too short )`;
                            // }}
                            onChange={this._onChange}
                            onEnterKey={this._onConfirmed}
                        />

                    </TextRun>

                    {this._renderButtonsRow()}

                </Column>
            </Dialog>
        );
    }
}
